<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)" *ngIf="!carInformacionInicial">
  <p-accordionTab header="{{'PAQUETESEGUROS.LBL_DATOSPRINCIPALES'|translate}}" [selected]="tabSeleccionado === 'DATOSPRINCIPALES'">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fPalabraClave"
                name="nomPalabraClave">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'PAQUETESEGUROS.LBL_CODIGO' | translate }}</label>
                  <div *ngIf="!paqSeguros">
                    <input type="text" pInputText id="codigo"
                           name="nomCodigo"
                           autocomplete="off"
                           formControlName="codigo"
                           maxlength="6"
                           (blur)="validarCodigo()"
                           codigos-reactive
                    >
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                      {{ 'PAQUETESEGUROS.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                      {{ 'MSG_CODIGOEXISTE' | translate}}
                    </div>
                  </div>
                  <div *ngIf="paqSeguros && paqSeguros.idPaqueteSeguro">
                    <label class="falso-combo-texto">{{paqSeguros.codigo}}</label>
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'PAQUETESEGUROS.LBL_NOMBRE' | translate }}</label>
                  <input type="text" pInputText id="nombre"
                         name="nomNombre"
                         autocomplete="off"
                         formControlName="nombre"
                         [maxlength]="50"
                         capitalize-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                    {{ 'PAQUETESEGUROS.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>

                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'PAQUETESEGUROS.LBL_MONTOMINIMO' | translate }}</label>
                  <input type="text" pInputText id="montoMinimo"
                         name="nomMontoMinimo"
                         autocomplete="off"
                         formControlName="montoMinimo"
                         [maxlength]="18"
                         currencyMask
                         (blur)="validarValor($event, true)"
                         [options]="{  thousands: appSettingService.separadorMiles,
                               decimal: appSettingService.separadorDecimales, align: 'left', allowNegative:false, precision : 0 }"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMinimo.invalid">
                    {{ 'PAQUETESEGUROS.LBL_MONTOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="!rangoMontoValido">
                    {{ 'PAQUETESEGUROS.MSG_ERRORRANGO' | translate }}
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'PAQUETESEGUROS.LBL_MONTOMAXIMO' | translate }}</label>
                  <input type="text" pInputText id="montoMaximo"
                         name="nomMontoMaximo"
                         autocomplete="off"
                         formControlName="montoMaximo"
                         [maxlength]="18"
                         currencyMask
                         (blur)="validarValor($event, true)"
                         [options]="{ thousands: appSettingService.separadorMiles,
                               decimal: appSettingService.separadorDecimales, align: 'left', allowNegative:false, precision : 0 }"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMaximo.invalid">
                    {{ 'PAQUETESEGUROS.LBL_MONTOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && !rangoInvalido">
                    {{ 'PAQUETESEGUROS.MSG_RNGOMONTOAPRMINMAXEXISTE' | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorTradicional" binary="true"></p-checkbox>
                  <label class="pl-2">{{'PAQUETESEGUROS.LBL_SOLITRADI' | translate}}</label>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorDigital" binary="true"></p-checkbox>
                  <label class="pl-2">{{'PAQUETESEGUROS.LBL_CREDIT' | translate}}</label>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorHabilitado" binary="true"></p-checkbox>
                  <label class="pl-2">{{'LBL_HABILITADO' | translate}}</label>
                </div>
              </div>
            </div>
            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                        type="submit"
                        pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
      </div>
    </div>
  </p-accordionTab>

  <p-accordionTab header="{{'PAQUETESEGUROS.LBL_TABPAQUETESEGUROS'|translate}}"
                  [selected]="tabSeleccionado === 'TABPAQUETESEGUROS'"
                  [disabled]="!paqSeguros"
                  *ngIf="paqSeguros && paqSeguros.idPaqueteSeguro">

    <app-paquete-seguros-seguros [paquete]="paqSeguros"></app-paquete-seguros-seguros>

  </p-accordionTab>


</p-accordion>



<div class="grid form-footer-buttons">
  <div class="form-group col-12">
    <div>
      <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
              type="button" (click)="regresar(false)"
              pButton></button>
    </div>
  </div>
</div>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
